import { useContext } from 'react'
import { ToastsContext } from '../state/contexts'

export const useToast = () => useContext(ToastsContext)
